import React from 'react'
import { InputNumber } from 'rsuite'

export interface FilterNumberRangeProps {
  from?: number | string
  to?: number | string
  onFromChange: (value: number | string | null) => void
  onToChange: (value: number | string | null) => void
  placeholderFrom?: string
  placeholderTo?: string
  min?: number
  max?: number
  step?: number
}

export default function FilterNumberRange ({
  from,
  to,
  onFromChange,
  onToChange,
  placeholderFrom = 'От',
  placeholderTo = 'До',
  min,
  max,
  step = 1
}: FilterNumberRangeProps) {
  return (
    <div className="FilterField--inline">
      <InputNumber
        value={from}
        onChange={onFromChange}
        placeholder={placeholderFrom}
        size="sm"
        min={min}
        max={max}
        step={step}
      />
      <InputNumber
        value={to}
        onChange={onToChange}
        placeholder={placeholderTo}
        size="sm"
        min={min}
        max={max}
        step={step}
      />
    </div>
  )
}
